module.exports = "<div class=\"hidden-md hidden-sm hidden-xs\" ng-include=\"'app/modules/trains-base/templates/flights/trains-filters-desktop.html'\"></div><div ng-include=\"'app/modules/trains-base/templates/flights/trains-filters-tablet.html'\" class=hidden-lg></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trains-base/templates/flights/trains-filters.html
// module id = 3267
// module chunks = 0